// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Location(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Location" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19 10.3636C19 6.29645 15.8663 3 12 3C8.13367 3 5 6.29645 5 10.3636C5 13.0743 7.33333 16.6203 12 21C16.6667 16.6203 19 13.0743 19 10.3636ZM12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Location.js.map